import { Box, Button, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const Page404 = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const handleToIndex = () => {
		navigate('/', { replace: true });
	};

	return (
		<Box
			sx={{
				minHeight: '100vh',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				p: 2,
			}}
		>
			<Stack spacing={3} alignItems='center'>
				<Typography
					sx={{
						fontSize: { xs: '6.5rem', sm: '8.5rem' },
						lineHeight: 1,
						color: 'text.secondary',
					}}
				>
					404
				</Typography>

				<Stack spacing={1.25} alignItems='center'>
					<Typography variant='h5' fontWeight={700} color='text.primary'>
						{t('errorMessage.page404')}
					</Typography>
					<Typography
						variant='body1'
						color='text.secondary'
						sx={{ maxWidth: 360 }}
					>
						{t('errorMessage.notFind')} {t('errorMessage.toIndex')}
					</Typography>
				</Stack>

				<Button
					variant='contained'
					size='large'
					onClick={handleToIndex}
					sx={{ mt: 1, px: 4, borderRadius: 2 }}
				>
					{t('button.backToHome')}
				</Button>
			</Stack>
		</Box>
	);
};

export default Page404;
